import { SvgIcon, SvgIconProps } from "@mui/material";

export function FactCheckIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M20,3 C21.1,3 22,3.9 22,5 L22,19 C22,20.1 21.1,21 20,21 L4,21 C2.9,21 2,20.1 2,19 L2,5 C2,3.9 2.9,3 4,3 Z M20,5 L4,5 L4,19 L20,19 L20,5 Z M10,15 L10,17 L5,17 L5,15 L10,15 Z M17.99,9 L19.41,10.42 L14.82,15 L12,12.16 L13.41,10.75 L14.82,12.17 L17.99,9 Z M10,11 L10,13 L5,13 L5,11 L10,11 Z M10,7 L10,9 L5,9 L5,7 L10,7 Z" />
    </SvgIcon>
  );
}
